import React from 'react';
import styled from 'styled-components';
import { Icon } from '../icon/Icon';
import { Loader } from '../loader';
import { makeButtonIcon, makeDefaultButton, makeDisabledButton } from './mixins';
export const ButtonIcon = styled(Icon) `
  ${(props) => makeButtonIcon(props)}
`;
export const DefaultButton = styled.button `
  ${(props) => makeDefaultButton(props)}
`;
export const DisabledButtonComponent = styled(DefaultButton) `
  ${(props) => makeDisabledButton(props)}
`;
const LoadingButton = (props) => {
    const { children, buttonoptions } = props;
    return (React.createElement(DisabledButtonComponent, Object.assign({}, Object.assign(Object.assign({}, props), { disabled: true }), buttonoptions, { content: children }),
        React.createElement(Loader, null)));
};
const DisabledButton = (props) => {
    const { icon, children, buttonoptions } = props;
    return (React.createElement(DisabledButtonComponent, Object.assign({}, props, buttonoptions, { content: children }),
        icon && icon.name && React.createElement(ButtonIcon, Object.assign({}, icon, { buttonoptions: buttonoptions, content: children })),
        children));
};
const ButtonComponent = (props) => {
    const { id, icon, children, buttonoptions } = props;
    return (React.createElement(DefaultButton, Object.assign({ id: id }, props, buttonoptions, { content: children }),
        icon && icon.name && React.createElement(ButtonIcon, Object.assign({}, icon, { buttonoptions: buttonoptions, content: children })),
        children));
};
export const Button = (props) => {
    const { disabled = false, isLoading = false } = props;
    if (isLoading) {
        return LoadingButton(props);
    }
    if (disabled) {
        return DisabledButton(props);
    }
    return ButtonComponent(props);
};
